import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxContainer } from './FilterCheckbox.styled';

const FilterCheckbox = ({ label, checked, onChange }) => (
  <CheckboxContainer>
    <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
    <span>{label}</span>
  </CheckboxContainer>
);

FilterCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default FilterCheckbox;


